<template>
  <toast />
  <v-card class="d-flex flex-column fill-height">
    <v-toolbar color="primary" max-height="64">
      <v-toolbar-title class="mx-5 altfont title-with-vin" v-if="model && !isSmallScreen">
        <div class="d-flex flex-column">
          <span>{{ model.name }}</span>
          <div v-if="vin" class="d-flex align-center vin-subtitle">
            <span>{{ vin }}</span>
            <v-btn :icon="true" size="x-small" @click="$emit('removeVIN')" class="ml-1">
              <v-icon size="x-small">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-select
        class="parts-mode-select"
        v-if="sheet && !navigation"
        v-model="sheet"
        :items="filteredSheets"
        @update:modelValue="changeSheet($event)"
        item-title="description"
        item-value="id"
        label="Sheet"
        return-object
        hide-details
        variant="solo"
        density="compact"
        bg-color="#fffe"
      >
        <template v-slot:selection="{ item }">
          <intendation :level="item.raw.indentationLevel" />
          {{ selectText(item.raw) }}
        </template>
        <template v-slot:item="{ item, props }">
          <v-list-item v-bind="props" :title="null">
            <intendation :level="item.raw.indentationLevel" />
            {{ item.raw.description }}
          </v-list-item>
        </template>
      </v-select>

      <!-- go home not shown, model is in dialog -->
      <!--      <v-btn icon @click="goHome" v-tooltip.bottom-center="$t('home-page')">-->
      <!--        <v-icon>mdi-home</v-icon>-->
      <!--      </v-btn>-->

      <login-button v-if="loginButtonEnabled" size="medium"></login-button>

      <v-btn icon @click="inin.reset()" v-tooltip.bottom-center="$t('cortona.ipc.reset-view')" class="d-print-none">
        <v-icon>mdi-camera-retake</v-icon>
      </v-btn>

      <v-btn
        icon
        v-if="!((sheet && !sheet.drawing) || svgOnly)"
        @click="inin.toggleDrawingMode()"
        :disabled="(sheet && !sheet.drawing) || svgOnly"
        v-tooltip.bottom-center="$t('cortona.ipc.switch2d')"
        class="d-print-none"
      >
        <v-icon>mdi-image-size-select-actual</v-icon>
      </v-btn>

      <cart ref="cart" />

      <!-- language picker only on main page, not in dialog -->
      <!--      <language-picker class="d-print-none" @change="$emit('reload')"></language-picker>-->

      <v-btn icon @click="openVinDialog" v-tooltip.bottom-center="$t('cortona.ipc.enter-vin')" class="d-print-none">
        <v-icon>mdi-identifier</v-icon>
      </v-btn>

      <v-app-bar-nav-icon
        @click="updateDrawerState"
        v-tooltip.bottom-center="ipcDrawer ? $t('cortona.ipc.hide-parts') : $t('cortona.ipc.show-parts')"
        class="d-print-none"
      ></v-app-bar-nav-icon>

      <v-btn
        v-if="isAdmin && !isResourcePublished"
        icon
        variant="plain"
        color="warning"
        v-tooltip.bottom-center="$t('cortona.ipc.resource-not-published', { status: model && model.status })"
        class="d-print-none"
      >
        <v-icon>mdi-alert-outline</v-icon>
      </v-btn>

      <!-- TODO dlaczego to jest wewnątrz, a nie w headerze dialogu? -->
      <v-btn icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text class="pa-0 flex-grow-1 d-flex flex-column">
      <div class="page-container-ipc">
        <cortona-loader
          v-model="inin"
          :type="model.type"
          :modelPath="model.additionalParams.interactivityXml"
          ref="inin"
          @update="updateData"
          @sheetSelected="onSheetSelected"
          @changeVisibility="changeVisibility"
          @selectFirstRowOnVariantNavi="selectFirstRowOnVariantNavi"
          :key="model.id"
          class="cortona-loader-container"
        />

        <div
          v-show="ipcDrawer"
          class="parts-drawer"
          :style="isLargeScreen ? { width: drawerWidth + 'px' } : {}"
        >
          <v-data-table
            class="parts-data-table"
            :headers="tableHeaders"
            :items="filteredTableItems"
            :loading="!filteredTableItems.length"
            :items-per-page="-1"
            item-value="viewPartSequence"
          >
            <template v-slot:headers="{ columns }">
              <tr>
                <th v-for="column in columns" :key="column.key" :style="{ width: column.width + 'px' }">
                  <template v-if="column.key === 'empty'">
                    <v-btn
                      v-if="hasHistory"
                      icon
                      variant="plain"
                      @click="goBack"
                      v-tooltip.bottom-center="$t('actions.back')"
                      color="primary"
                      size="large"
                    >
                      <v-icon>mdi-arrow-left-circle</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    {{ column.title }}
                  </template>
                </th>
              </tr>
            </template>

            <template v-slot:item="{ item }">
              <tr
                @mouseover="hoverRow(item.viewPartSequence)"
                @mouseleave="hoverRow(-1)"
                @click="rowClicked(item.viewPartSequence)"
                :class="{ hovered: item.viewPartSequence === hovered, selected: item.viewPartSequence === selected }"
              >
                <td class="td-checkbox">
                  <v-checkbox
                    v-model="visible[item.sequence]"
                    @update:model-value="inin.setVisibility(item)"
                    hide-details
                    density="compact"
                    :disabled="sheetLocked"
                    v-show="!svgMode && !isVariantNavi"
                    true-icon="mdi-eye"
                    false-icon="mdi-eye-off-outline"
                    @click.stop
                    v-tooltip.left="visible[item.sequence] ? $t('cortona.ipc.hide-object') : $t('cortona.ipc.show-object')"
                    class="d-print-none visibility-checkbox"
                  />
                </td>
                <td v-for="header in notEmptyTableHeaders" :key="'row' + item.viewPartSequence + header.key">
                  <intendation v-if="header.key == 'DESCR'" :level="item.viewIndent" />
                  {{ item.tableCells[header.key] }}
                </td>
                <td class="td-actions">
                  <v-btn
                    icon
                    variant="plain"
                    v-if="!navigation"
                    @click.stop="addToCart(item)"
                    color="primary"
                    size="default"
                    v-tooltip.left="$t('cortona.ipc.add-to-cart')"
                    class="d-print-none"
                  >
                    <v-icon>mdi-cart-plus</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    variant="plain"
                    v-if="item.url"
                    @click="changeModel(item.url)"
                    color="primary"
                    size="default"
                    v-tooltip.left="$t('cortona.ipc.go-to-model')"
                  >
                    <v-icon>mdi-arrow-right-circle</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:bottom></template>
          </v-data-table>
        </div>
      </div>
    </v-card-text>

    <v-dialog v-model="vinDialogVisible" max-width="400">
      <v-card>
        <v-card-title>{{ $t('cortona.ipc.enter-vin') }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="vinInput"
            :label="$t('cortona.ipc.vin-label')"
            variant="outlined"
            autofocus
            clearable
            :error-messages="vinNotFoundError ? $t('cortona.ipc.vin-not-found') : ''"
            @keyup.enter="applyVin"
            @input="vinNotFoundError = false"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="vinDialogVisible = false">{{ $t('action.cancel') }}</v-btn>
          <v-btn color="primary" :loading="vinSearchLoading" @click="applyVin">{{ $t('cortona.ipc.vin-apply') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import CortonaLoader from './CortonaLoader.vue';
import Intendation from '../basic/Intendation.vue';
import Cart from '../cart/Cart.vue';
import { debounce } from 'debounce';
import LanguagePicker from '../basic/LanguagePicker.vue';
import LoginButton from '@/venit/components/cortona-venit/components/login/LoginButton.vue';
import { useCortonaViewerStore } from '@/stores/cortonaViewer';
import { useAccountStore } from '@/stores/account';
import api from '../../services/api';
import Toast from '../basic/Toast.vue';

export default {
  name: 'CortonaIPC',
  components: {
    LoginButton,
    CortonaLoader: CortonaLoader,
    Intendation,
    Cart,
    LanguagePicker,
    Toast,
  },
  props: {
    model: Object,
    vin: String,
    autoSelectView: String,
    autoSelectPart: String,
  },
  emits: ['closeDialog', 'modelNavigation', 'reload', 'removeVIN', 'updateVIN'],
  data: () => ({
    inin: null,
    navigation: false,
    isVariantNavi: false,
    sheet: null,
    sheets: [],
    hovered: null,
    selected: null,
    console,
    ipcDrawer: true,
    clickedRecently: false,
    visible: [],
    sheetLocked: false,
    svgMode: false,
    svgOnly: false,
    loginButtonEnabled: true,
    autoSelectApplied: false,
    vinDialogVisible: false,
    vinInput: '',
    vinNotFoundError: false,
    vinSearchLoading: false,
  }),
  watch: {
    ipcDrawer: {
      handler(current, prev) {
        // console.log('drawer changed value to', current);
      },
    },
    filteredSheets() {
      this.handleAutoSelect();
    },
    sheet() {
      this.handleAutoSelect();
    },
  },
  methods: {
    openVinDialog() {
      this.vinInput = this.vin || '';
      this.vinNotFoundError = false;
      this.vinDialogVisible = true;
    },
    async applyVin() {
      const value = this.vinInput?.trim() || null;
      if (value) {
        this.vinSearchLoading = true;
        try {
          const result = await api.getSerialNumberInfo(value);
          if (!result) {
            this.vinNotFoundError = true;
            return;
          }
        } finally {
          this.vinSearchLoading = false;
        }
      }
      this.$emit('updateVIN', value);
      this.vinDialogVisible = false;
    },
    handleAutoSelect() {
      if (this.autoSelectApplied || !this.autoSelectView) return;
      if (!this.filteredSheets.length || !this.sheet) return;

      const targetSheet = this.filteredSheets.find(sh => sh.id === this.autoSelectView);
      if (!targetSheet) {
        this.autoSelectApplied = true;
        return;
      }

      if (this.sheet.id !== this.autoSelectView) {
        this.changeSheet(targetSheet);
        return;
      }

      if (this.autoSelectPart) {
        this.$nextTick(() => {
          const targetItem = this.filteredTableItems.find(item => item.partRefId === this.autoSelectPart);
          if (targetItem) {
            this.selected = targetItem.viewPartSequence;
            this.inin?.selectRow(targetItem.viewPartSequence);
          }
          this.autoSelectApplied = true;
        });
      } else {
        this.autoSelectApplied = true;
      }
    },
    updateDrawerState() {
      this.ipcDrawer = !this.ipcDrawer;
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    goBack() {
      const cortonaViewerStore = useCortonaViewerStore();
      cortonaViewerStore.goBackToPreviousModel();
      this.$emit('modelNavigation', cortonaViewerStore.currentModel);
    },
    goHome() {
      this.$router.push({ name: 'root' });
    },
    updateData(name, value) {
      this[name] = value;
    },
    changeSheet(sheet) {
      if (sheet) {
        this.inin.changeSheet(sheet);
      }
    },
    onSheetSelected(sheet) {
      let found = this.filteredSheets.find(sh => sh.id == sheet.id);
      if (found) {
        this.sheet = found;
        this.selectFirstRowOnVariantNavi();
      } else this.changeSheet(this.filteredSheets[0]);
    },
    selectFirstRowOnVariantNavi() {
      this.$nextTick(() => {
        if (this.isVariantNavi && this.filteredTableItems?.length) {
          this.hoverRow(this.filteredTableItems[0].viewPartSequence);
        }
      });
    },
    changeVisibility(params) {
      let { hidden, rows } = params;
      rows.forEach(rowIndex => {
        let row = this.filteredTableItems.find(item => item.viewPartSequence == rowIndex);
        if (row) this.visible[row.sequence] = !hidden;
      });
    },
    async changeModel(url) {
      if (url) {
        try {
          await api.getResource(url, null, this.$i18n.locale);
        } catch (e) {
          const accountStore = useAccountStore();
          const isAdmin = accountStore.account?.userType === 'ADMIN';
          const cortonaViewerStore = useCortonaViewerStore();
          cortonaViewerStore.showToast({
            message: this.$t('cortona.ipc.model-not-found'),
            type: 'info',
            timeout: 3000,
            ...(isAdmin ? { copyText: url } : {}),
          });
          return;
        }
        const cortonaViewerStore = useCortonaViewerStore();
        cortonaViewerStore.navigateToModel(url, false);
        this.$emit('modelNavigation', url);
      }
    },
    rowClicked(index) {
      if (!this.sheetLocked) {
        if (this.clickedRecently) {
          this.inin.fitIntoView(index);
        } else {
          setTimeout(() => {
            if (this.clickedRecently) {
              this.inin.selectRow(index);
            }
            this.clickedRecently = false;
          }, 200);
        }
        this.clickedRecently = !this.clickedRecently;
      }
    },
    hoverRow: debounce(function (index) {
      if (!this.sheetLocked && this.inin) this.inin.hoverRow(index);
    }, 200),
    addToCart(item) {
      this.$refs.cart.add({ ...this.inin.getItemInfo(item.viewPartSequence), partName: item.tableCells['DESCR'], resourceId: this.model.id });
    },
    filterCells(cells, sheet) {
      let newCells = {};
      Object.keys(cells).forEach(key => {
        let val = cells[key];
        const rgx = /KEY:\s*(\S*)\s*VALUE:\s*(\S*)\s*/g;
        let match;
        let found = [];
        while ((match = rgx.exec(val))) {
          found.push({ key: match[1], val: match[2] });
        }
        if (found.length) {
          newCells[key] = found.find(x => !x.key || x.key === sheet)?.val;
        } else newCells[key] = val;
        newCells[key] = newCells[key].replace(/^•+/, ''); //indent dots removal
      });
      return newCells;
    },
    calculateColumnWidth(headerKey, headerText) {
      let width = this.filteredTableItems
        .map(part => part.tableCells[headerKey]?.length)
        .reduce((max, width) => Math.max(max, width), headerText?.length);
      return width * 6;
    },
  },
  updated() {
    this.$refs.inin.resizeFrame();
  },
  computed: {
    isAdmin() {
      const accountStore = useAccountStore();
      return accountStore.account?.userType === 'ADMIN';
    },
    isResourcePublished() {
      return !this.model || this.model.status === 'PUBLISHED';
    },
    isSmallScreen() {
      return this.$vuetify.display.width < 768;
    },
    isLargeScreen() {
      return this.$vuetify.display.width > 1264;
    },
    drawerWidth() {
      const screenWidth = this.$vuetify.display.width;
      return this.isLargeScreen ? Math.round(screenWidth * 0.4) : (screenWidth*0.5);
    },
    selectText() {
      return item => {
        if (this.isSmallScreen) {
          const words = item.description.split(' ');
          return words.length > 0 ? words[words.length - 1] : '';
        }
        return item.description;
      };
    },
    hasHistory() {
      const cortonaViewerStore = useCortonaViewerStore();
      return cortonaViewerStore.modelHistory.length > 0;
    },
    filteredTableItems() {
      if (!this.model || !this.sheet) return [];
      let view = this.model.cortonaIpc.views.find(v => v.id === this.sheet.id);

      let maxseq = Math.max(...view.parts.map(p => p.sequence));
      while (maxseq >= this.visible.length) this.visible.push(true);

      let sheet = this.sheet.description.split('=')[1]?.trim();
      return view.parts.map(part => ({
        ...part,
        tableCells: this.filterCells(part.tableCells, sheet),
      }));
    },
    filteredSheets() {
      if (!this.model || !this.sheets.length || !this.model.cortonaIpc) return []; // TODO mari model.cortonaIpc
      let views = this.model.cortonaIpc.views.map(v => v.id);
      return this.sheets.filter(sh => views.includes(sh.id));
    },
    tableHeaders() {
      if (!this.model || !this.sheet) return [];
      let view = this.model.cortonaIpc.views.find(v => v.id === this.sheet.id);
      let translated = view.headers
        .filter(h => h.value)
        .map(header => {
          const i18nKey = `cortona-ipc-table-header.${header.value}`;
          let translatedHeaderText = this.$te(i18nKey) ? this.$t(i18nKey) : (header.text || header.value);
          return {
            ...header,
            key: header.value,
            title: translatedHeaderText,
            sortable: false,
            width: this.calculateColumnWidth(header.value, translatedHeaderText),
          };
        });
      let headers = [{ key: 'empty', width: 32, sortable: false }, ...translated, { key: 'actions', width: 48, sortable: false }];
      return headers;
    },
    notEmptyTableHeaders() {
      return this.tableHeaders.filter(h => h.key && h.key !== 'empty' && h.key !== 'actions');
    },
  },
};
</script>

<style lang="scss" scoped>
.title-with-vin :deep(.v-toolbar-title__placeholder) {
  white-space: normal;
  overflow: visible;
  line-height: 1.2;
}

.vin-subtitle {
  opacity: 0.85;
  font-size: 0.75rem;
  font-weight: 400;
}

.parts-mode-select {
  min-width: 300px;
  max-width: 450px;
  @media screen and (max-width: 768px) {
    min-width: 150px;
    max-width: 200px;
  }
}

.parts-data-table {
  table {
    table-layout: fixed;
  }

  @media screen and (max-width: 768px) {
    * {
      padding: 0.1rem !important;
    }

    td {
      font-size: 0.7rem !important;
    }

    th * {
      font-size: 0.7rem !important;
    }
  }
}

/*
html {
  overflow-y: auto;
  overflow-x: hidden;
}

.main {
  max-height: 100vh;
}
*/

.page-container-ipc {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  @media screen and (min-width: 1264px) {
    flex-direction: row;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 10px;
    z-index: 1;
    pointer-events: none;
    background: linear-gradient(to bottom,
      rgb(var(--v-theme-accent)) 0px,
      rgb(var(--v-theme-accent)) 5px,
      rgb(var(--v-theme-primary)) 5px,
      rgb(var(--v-theme-primary)) 10px
    );
  }
}

.cortona-loader-container {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;

  @media screen and (max-width: 1263px) {
    flex: 0 0 60%;
  }
}

.parts-drawer {
  flex: 0 0 auto;
  overflow-y: auto;
  background-color: white;
  border-left: 1px solid #e0e0e0;

  @media screen and (max-width: 1263px) {
    flex: 1 1 40%;
    border-left: none;
    border-top: 1px solid #e0e0e0;
    max-height: 40%;
  }
}

.altfont {
  font-family: 'Saira Semi Condensed', sans-serif;
  font-size: 1.5rem !important;
}

.td-checkbox {
  width: 40px;
  padding: 0 !important;
}

.visibility-checkbox {
  display: flex;
  justify-content: center;
}

.visibility-checkbox :deep(.v-selection-control) {
  min-height: auto;
}

.visibility-checkbox :deep(.v-selection-control__wrapper) {
  margin: 0;
}

.td-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
  padding: 0 !important;
}

/*
.v-toolbar__content {
  gap: 1rem;

  @media screen and (max-width: 768px) {
    gap: 0 !important;
  }
}

.header-bar-REMOVED {
  position: relative;
  filter: drop-shadow(0px 2px 3px #000a);
  @media screen {
    &::after {
      content: '';
      position: absolute;
      height: 2rem;
      background-color: rgb(var(--v-theme-primary));
      width: 100%;
      --cut: 2rem;
      clip-path: polygon(0 0, 100% 0%, 100% calc(100% - var(--cut)), 0% 100%);

      // top: 4rem;
      // left: 0;
      // border-right: 100vw solid transparent;
      // border-top: 2rem solid rgb(var(--v-theme-primary));
    }
  }
}
*/

.v-data-table tbody tr {
  transition: background-color 0.5s ease;

  &.hovered,
  &:hover {
    background-color: #ced3d1 !important;
  }

  &.selected {
    background-color: rgb(var(--v-theme-accent)) !important;
  }
}


tr.link {
  background-color: rgb(var(--v-theme-secondary)) !important;
  cursor: pointer;
}
</style>
